__turbopack_context__.v({
  "container": "_6YHjbq_container",
  "fluid": "_6YHjbq_fluid",
  "lg": "_6YHjbq_lg",
  "md": "_6YHjbq_md",
  "sm": "_6YHjbq_sm",
  "xl": "_6YHjbq_xl",
});
